<template>
  <div :class="getClass">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'GridRow',
  props: {
    cols: {
      type: Number,
      default: 3
    }
  },
  computed: {
    getClass() {
      return `grid-row grid-row--${this.cols}-col`
    }
  }
}
</script>

<style lang="postcss">
.grid-row {
  @apply flex flex-wrap -mx-4 mb-4;
}
.grid-col {
  @apply px-4 pb-8 flex;
}
.grid-row--2-col .grid-col {
  @apply w-full;
}
.grid-row--3-col .grid-col {
  @apply w-full;
}
.grid-row--4-col .grid-col {
  @apply w-full;
}
@screen sm {
  .grid-row--2-col .grid-col {
    @apply w-1/2 min-w-1/2;
  }
  .grid-row--4-col .grid-col {
    @apply w-1/2 min-w-1/2;
  }
  /* We should avoid these type of overrides where a class changes based on 
  the prescence of another class futher up the document */
  .page.modal .grid-row--2-col .grid-col {
    @apply w-full;
  }
}
@screen md {
  .grid-row--3-col .grid-col {
    @apply w-1/3 min-w-1/3;
  }
  .grid-row--4-col .grid-col {
    @apply w-1/3 min-w-1/3;
  }
  /* We should avoid these type of overrides where a class changes based on 
  the prescence of another class futher up the document */
  .page.modal .grid-row--2-col .grid-col {
    @apply w-1/2 min-w-1/2;
  }
}
</style>
